var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.756,
    viewBox: "0 0 18 15.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-justify",
    transform: "translate(-2.2 -5.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_1038",
    "data-name": "Line 1038",
    d: "M16.729.424H-.329A.555.555,0,0,1-.8-.188.555.555,0,0,1-.329-.8H16.729a.555.555,0,0,1,.471.612A.555.555,0,0,1,16.729.424Z",
    transform: "translate(3 10.715)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1039",
    "data-name": "Line 1039",
    d: "M16.729.424H-.329A.555.555,0,0,1-.8-.188.555.555,0,0,1-.329-.8H16.729a.555.555,0,0,1,.471.612A.555.555,0,0,1,16.729.424Z",
    transform: "translate(3 6.126)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1040",
    "data-name": "Line 1040",
    d: "M16.729.424H-.329A.555.555,0,0,1-.8-.188.555.555,0,0,1-.329-.8H16.729a.555.555,0,0,1,.471.612A.555.555,0,0,1,16.729.424Z",
    transform: "translate(3 15.304)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1041",
    "data-name": "Line 1041",
    d: "M16.729.424H-.329A.555.555,0,0,1-.8-.188.555.555,0,0,1-.329-.8H16.729a.555.555,0,0,1,.471.612A.555.555,0,0,1,16.729.424Z",
    transform: "translate(3 20.658)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignicon1);
export default __webpack_public_path__ + "static/media/Alignicon1.3f6c4ea3e799b9d6dc983965b6fa4fcf.svg";
export { ForwardRef as ReactComponent };